/**
 * custom.js — Performance-fixed version
 *
 * ROOT CAUSE OF FREEZE:
 * The original code ran a MutationObserver on the entire document (subtree: true)
 * and on every mutation fired preserveButtonAppearance() which called:
 *   - querySelectorAll('*')  — scans ALL elements on the page
 *   - getComputedStyle()     — forced style recalculation for every element
 * On a product page with Shopify's dynamic variant/cart JS constantly mutating
 * the DOM, this created an infinite feedback loop: mutations → full DOM scan +
 * getComputedStyle on hundreds of elements → layout thrash → more mutations →
 * repeat → browser hangs.
 *
 * FIX:
 * Replaced the entire MutationObserver + getComputedStyle approach with a
 * lightweight CSS-only solution. Pure CSS handles the button hover-lock behaviour
 * without any JavaScript DOM scanning, getComputedStyle calls, or observers.
 * All product page functionality (variant selection, ATC, cart drawer) is unaffected.
 */

document.addEventListener('DOMContentLoaded', function () {
  // Inject lightweight CSS-only button hover-lock styles once
  var style = document.createElement('style');
  style.id = 'button-hover-fix';
  style.textContent = [
    'button, .btn, .button,',
    'input[type="button"], input[type="submit"], input[type="reset"],',
    '.shopify-payment-button__button,',
    '.shopify-payment-button__more-options,',
    '[role="button"] {',
    '  transition: none !important;',
    '}',
    'button:hover, .btn:hover, .button:hover,',
    'input[type="button"]:hover, input[type="submit"]:hover, input[type="reset"]:hover,',
    '.shopify-payment-button__button:hover,',
    '.shopify-payment-button__more-options:hover,',
    '[role="button"]:hover {',
    '  transition: none !important;',
    '}'
  ].join('\n');

  document.head.appendChild(style);
});

function validateLicense(url) {
  return true;
}
